import React from "react";
import styled from "styled-components";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import { CgRedo } from "react-icons/cg";
import { useModal } from "hooks";
import { TaskViewModal } from "modals";
export const TableRow = ({ isLoading, status }) => {
  const viewModal = useModal();
  const handleClick = () => {
    viewModal.openModal();
  };

  return isLoading ? (
    <SkeletonTheme color="#202020" highlightColor="#444">
      <Container isLoading>
        <div className="inner">
          <RowItem>
            <Skeleton height={32} />
          </RowItem>
          <RowItem>
            <Skeleton height={32} />
          </RowItem>
          <RowItem>
            <Skeleton height={32} />
          </RowItem>
          <RowItem>
            <Skeleton height={32} />
          </RowItem>
          <RowItem>
            <Skeleton height={32} />
          </RowItem>
          <RowItem>
            <Skeleton height={32} />
          </RowItem>
        </div>
      </Container>
    </SkeletonTheme>
  ) : (
    <Container status={status} onClick={handleClick}>
      <div className="inner">
        <RowItem></RowItem>
        <RowItem>Product 1</RowItem>
        <RowItem>Crawling</RowItem>
        <RowItem>Scrapper</RowItem>
        <RowItem>20 days ago</RowItem>
        <RowItem className="d-flex">
          <span>https://walmart.com</span>
          {status === "error" && (
            <div className="ml-auto cursor-pointer mr-2">
              <CgRedo size={24} />
            </div>
          )}
        </RowItem>
      </div>
      {status === "error" && (
        <Error>
          Error: Tasks failed, please review task errors <a href="/#">here</a>.
        </Error>
      )}
      <TaskViewModal {...viewModal} />
    </Container>
  );
};

const Container = styled.div`
  background: ${(props) => props.theme.palette.items};
  display: block;
  color: white;
  transition: all 300ms ease;
  font-size: ${(props) => props.theme.palette.m};
  border: 1px solid ${(props) => props.theme.palette.gray};
  border-left: 12px solid
    ${(props) =>
      props.status === "success"
        ? props.theme.palette.success
        : props.status === "warning"
        ? props.theme.palette.warning
        : props.status === "info"
        ? props.theme.palette.info
        : props.status === "error"
        ? props.theme.palette.error
        : props.status === "none"
        ? props.theme.palette.white
        : props.theme.palette.secondary};

  margin: 3px 6px 3px 12px;
  border-radius: 2px;
  .inner {
    display: flex;
    width: 100%;
    padding: 0 0px 0 32px;
    height: 66px;
    cursor: pointer;
    &:hover {
      background: ${(props) =>
        props.isLoading
          ? props.theme.palette.items
          : props.theme.palette.itemsHover};
    }

    & > div:nth-child(1) {
      width: 0px;
    }
    & > div:nth-child(2) {
      flex: 1;
    }
    & > div:nth-child(3) {
      width: 120px;
    }
    & > div:nth-child(4) {
      width: 120px;
    }
    & > div:nth-child(5) {
      width: 120px;
    }
    & > div:nth-child(6) {
      width: 320px;
    }
  }
`;

const RowItem = styled.div`
  margin: auto 16px auto 0;
`;

const Error = styled.div`
  height: 40px;
  line-height: 40px;
  background: ${(props) => props.theme.palette.error};
  color: white;
  font-size: ${(props) => props.theme.font.size.m};
  padding-left: 40px;
  a {
    color: white;
    text-decoration: underline;
  }
`;
